// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__nclul","title":"title__iX0mU","tags":"tags__BHMFe","tag":"tag__5xYgX"};